import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { PlausibleAnalytics } from "./components/PlausibleAnalytics";
import { HomePage } from "./HomePage";
import { DocPage } from "./pages/DocPage";
import { ScenarioPreviewPage } from "./pages/ScenarioPreviewPage";

function routerBasename(): string | undefined {
  const b = import.meta.env.BASE_URL;
  if (b === "/" || b === "") return undefined;
  return b.endsWith("/") ? b.slice(0, -1) : b;
}

export default function App() {
  return (
    <BrowserRouter basename={routerBasename()}>
      <PlausibleAnalytics />
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/preview" element={<ScenarioPreviewPage />} />
          <Route path="/how-it-works" element={<DocPage kind="how" />} />
          <Route path="/privacy" element={<DocPage kind="privacy" />} />
          <Route path="/terms" element={<DocPage kind="terms" />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
